/**
 * Los 5 estratos de §4.2 (zona × participación histórica).
 *
 * Regla de estratificación (§4.2):
 *  - Secciones rurales (0724–0734) → D
 *  - Secciones de creación reciente (2044–2047) → E
 *  - Urbanas según participación 2024: A ≥ 52%, B 48–52%, C < 48%
 */
export const STRATUM_IDS = ['A', 'B', 'C', 'D', 'E'];
export const STRATA = [
    {
        id: 'A',
        name: 'Urbana consolidada',
        description: 'Primer cuadro y fraccionamientos con arraigo; mayor participación',
        sectionCount: 12,
        listaNominal2024: 18_951,
        padronShare: 0.196,
        participation2024: 0.54,
        coalicionMorena2024: 0.524,
        pesBc2024: 0.215,
        pan2024: 0.106,
        targetN: 156,
        theoreticalMarginOfError: 0.078,
        readAsTrendOnly: false,
        clusterCount: 8,
        ppsInterval: 2368.9,
        ppsRandomStart: 1007.1,
        coverageOfStratum: 0.67,
    },
    {
        id: 'B',
        name: 'Urbana pendular',
        description: 'Colonias intermedias; incluye las dos secciones más grandes (722 y 702) — estrato decisivo',
        sectionCount: 16,
        listaNominal2024: 46_513,
        padronShare: 0.48,
        participation2024: 0.494,
        coalicionMorena2024: 0.557,
        pesBc2024: 0.239,
        pan2024: 0.063,
        targetN: 384,
        theoreticalMarginOfError: 0.05,
        readAsTrendOnly: false,
        clusterCount: 19,
        ppsInterval: 2448.1,
        ppsRandomStart: 56.6,
        coverageOfStratum: 0.87,
    },
    {
        id: 'C',
        name: 'Urbana periférica',
        description: 'Colonias de baja participación',
        sectionCount: 3,
        listaNominal2024: 6_321,
        padronShare: 0.065,
        participation2024: 0.467,
        coalicionMorena2024: 0.574,
        pesBc2024: 0.225,
        pan2024: 0.031,
        targetN: 52,
        theoreticalMarginOfError: 0.136,
        readAsTrendOnly: true,
        clusterCount: 3,
        ppsInterval: 2107.0,
        ppsRandomStart: 675.5,
        coverageOfStratum: 0.91,
    },
    {
        id: 'D',
        name: 'Rural / semiurbana',
        description: 'Ejidos y poblados: Valle de las Palmas, La Rumorosa, El Hongo, Nueva Colonia Indú, Jácume',
        sectionCount: 11,
        listaNominal2024: 16_698,
        padronShare: 0.172,
        participation2024: 0.437,
        coalicionMorena2024: 0.598,
        pesBc2024: 0.115,
        pan2024: 0.068,
        targetN: 138,
        theoreticalMarginOfError: 0.083,
        readAsTrendOnly: false,
        clusterCount: 7,
        ppsInterval: 2385.4,
        ppsRandomStart: 1731.3,
        coverageOfStratum: 0.71,
    },
    {
        id: 'E',
        name: 'Mixta periférica reciente',
        description: 'Asentamientos de creación reciente',
        sectionCount: 4,
        listaNominal2024: 8_435,
        padronShare: 0.087,
        participation2024: 0.472,
        coalicionMorena2024: 0.556,
        pesBc2024: 0.245,
        pan2024: 0.045,
        targetN: 70,
        theoreticalMarginOfError: 0.117,
        readAsTrendOnly: true,
        clusterCount: 4,
        ppsInterval: 2108.8,
        ppsRandomStart: 931.3,
        coverageOfStratum: 1.0,
    },
];
export const STRATUM_BY_ID = Object.fromEntries(STRATA.map((s) => [s.id, s]));
/** Semilla del PPS sistemático (§5.1), reproducible. */
export const PPS_SEED = 20261011;
/** Totales del marco (§4.1) para verificación. */
export const FRAME_TOTALS = {
    sections: 46,
    casillas: 153,
    casillasExtraordinarias: 21,
    listaNominal2024: 96_918,
    participation2024: 0.49,
    listaNominal2026: 101_634,
    clusters: 41,
    selectedSections: 29,
    padronCoverage: 0.82,
    targetEffective: 800,
    /** Se programan 880 para absorber ~10% de anulaciones (§2). */
    targetProgrammed: 880,
};
//# sourceMappingURL=strata.js.map